import React, { useEffect, useState } from "react";
import styles from "./payoutview.module.css";
// import AddUserModal from "./AddUserModal";
// import UserNotification from "../components/Notification/UserNotifiaction/UserNotification";
import { Pagination, TablePagination } from "@mui/material";
import PayoutViewModal from "./payoutViewModal/PayoutViewModal";
import FilterModal from "../FilterModal/FilterModal";
import RejectReasonModal from "./payoutViewModal/PayoutRejectModal/PayoutRejectModal";
import { useAllProduct } from "../../api-context/commonApiContext";
import config from "../../service/config";
import FullScreenLoader from "../../reusable/loader/FullScreenLoader";
const PayoutView = () => {
  const {
    role,
    approverLimit,
    clientId,
    selectedCompanyName,
    selectedEscrowName,
    loading,
    setLoading,
  } = useAllProduct();
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(8);
  const [showModal, setShowModal] = useState(false);
  const [selectedRowVal, setSelectedRowVal] = useState({});
  const [userAdded, setUserAdded] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  const [payoutDetails, setPayoutDetails] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [reason, setReason] = useState("");

  const [selectedFilter, setSelectedFilter] = useState({
    status: "Approver L1", // ✅ Matches what backend sends
    actionType: "Pending",
  });

  const [filters, setFilters] = useState({
    status: "",
    actionType: "",
  });

  useEffect(() => {
    const fetchPayoutDetails = async () => {
      try {
        const queryParams = new URLSearchParams({
          clientId,
          selectedCompanyName,
          selectedEscrowName,
        });
        setLoading(true);
        const res = await fetch(
          `${
            config.node_api_endpoint
          }/api/payout-details?${queryParams.toString()}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "x-api-key": process.env.REACT_APP_API_KEY,
            },
          }
        );

        const result = await res.json();
        setLoading(false);
        if (result.success) {
          setRefreshData(false);
          result.data.forEach((item) => console.log(item.status));
          setPayoutDetails(result.data);
        } else {
          console.error("Failed to fetch payout details:", result.message);
        }
      } catch (err) {
        setLoading(false);
        console.error("Error fetching payout details:", err);
      }
    };

    fetchPayoutDetails();
  }, [refreshData, clientId, selectedCompanyName, selectedEscrowName]);

  const handleSave = () => {
    if (reason.trim()) {
      onSave(reason);
      onClose();
    }
  };

  const handlePaginationChange = (page, rowsPerPage) => {
    setCurrentPage(page);
    setItemsPerPage(rowsPerPage);
  };

  const getActionType = (status) => {
    if (!status) return "Pending";
    if (["Approved L1", "Approved L2", "Owner", "Completed"].includes(status)) {
      return "Completed";
    }
    return "Pending";
  };

  const filteredReports = payoutDetails.filter((report) => {
    const matchesSearch = Object.values(report).some((val) =>
      String(val).toLowerCase().includes(searchQuery)
    );

    const matchesStatus = !filters.status || report.status === filters.status;

    const matchesActionType =
      !filters.actionType ||
      getActionType(report.status) === filters.actionType;

    console.log("🔎 Filter Check — Report ID:", report.id);
    console.log("  Role.toString():", role?.toString());
    console.log("  Report Status:", report.status);
    console.log("  Report Action Type:", getActionType(report.status));
    console.log("  Current Filter:", filters);
    console.log("  ✅ matchesStatus:", matchesStatus);
    console.log("  ✅ matchesActionType:", matchesActionType);

    return matchesSearch && matchesStatus && matchesActionType;
  });

  console.log("✅ Matched reports count:", filteredReports.length);

  const paginatedReports = filteredReports.slice(
    currentPage * itemsPerPage,
    currentPage * itemsPerPage + itemsPerPage
  );
  const handleFilterClick = () => {
    setIsModalOpen(!isModalOpen); // Toggle modal visibility
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
  };

  const applyFilters = (newFilters) => {
    setFilters((prev) => ({
      ...prev,
      ...newFilters,
    }));
    setCurrentPage(0);
  };

  return (
    <>
      <FullScreenLoader spinning={loading} />
      <div className="d-flex justify-content-between">
        <div className={`${styles.title} mt-5`}>Payout View </div>
      </div>
      <div className={`${styles.root} mt-2`}>
        <section className={styles.transactionDataTable}>
          <div className={styles.top}>
            <div className={styles.reportHeader}>
              <h3 className={styles.latestAccountTransaction}>Payout List</h3>
              <div className={styles.filter}>
                <div className={styles.textField}>
                  <div className={styles.content}>
                    <img
                      className={styles.leadingIcon}
                      alt=""
                      src="/leadingicon.svg"
                    />
                    <input
                      className={styles.filterLabel}
                      placeholder="Search..."
                      type="text"
                      value={searchQuery}
                      onChange={(e) => {
                        setSearchQuery(e.target.value.toLowerCase());
                        setCurrentPage(0);
                      }}
                    />
                  </div>
                </div>
                <div
                  className={`${styles.filterLinesParent} mx-2 mousePointer`}
                  onClick={true ? handleFilterClick : (e) => e.preventDefault()} // Prevent click if disabled
                >
                  <img
                    className={styles.filterLinesIcon}
                    alt=""
                    src="/filterlines.svg"
                  />
                  <div className={styles.input1}>Filter</div>
                </div>
                <div className="w-100 d-flex justify-content-end position-relative">
                  {isModalOpen && (
                    <FilterModal
                      onClose={handleCloseModal}
                      page={"PayoutView"}
                      applyFilters={applyFilters}
                      selectedFilter={selectedFilter} // Pass selected filter
                      setSelectedFilter={setSelectedFilter} // Function to update filter
                    />
                  )}
                </div>
                <div className={styles.reLoadTable}>
                  <img
                    className={styles.reloadIcon}
                    loading="lazy"
                    alt=""
                    src="/reload.svg"
                    onClick={() => setRefreshData(true)}
                  />
                </div>
              </div>
            </div>
            <div className={styles.headerSeparator} />
          </div>

          <div className={styles.reportTable}>
            <div className={styles.tableHeader}>
              <div className={styles.cell}> Created at</div>
              <div className={styles.cell}>Beneficiary Name</div>
              <div className={styles.cell}>Amount (₹)</div>
              <div className={styles.cell}>A/c no/UPI ID</div>
              <div className={styles.cell}>Transaction Note </div>
              <div className={styles.cell}> Remarks</div>
              <div className={styles.cell}> UTR</div>
              <div className={styles.cell}> Status</div>
              <div className={styles.cell}> Action</div>
            </div>

            {paginatedReports.length === 0 ? (
              <div
                className={`d-flex justify-content-center align-items-center py-4`}
                style={{
                  textAlign: "center",
                  fontWeight: 500,
                  height: "30vh",
                }}
              >
                <div className=" w-100">No data available</div>
              </div>
            ) : (
              paginatedReports.map((report, index) => (
                <div className={styles.tableRow} key={index}>
                  <div className={styles.cell}>{report.created_at}</div>
                  <div className={styles.cell}>{report.beneficiary_name}</div>
                  <div className={styles.cell}>{report.amount}</div>
                  <div className={styles.cell}>{report.bank_account}</div>
                  <div className={styles.cell}>{report.transaction_note}</div>
                  <div className={styles.cell}>{report.internal_note}</div>
                  <div className={styles.cell}>{report.utr}</div>
                  <div className={styles.cell}>
                    <span
                      className={
                        report.status === "REJECTED"
                          ? styles.statusFailed
                          : report.status === "Approver L1" ||
                            report.status === "Approver L2"
                          ? styles.statusPending
                          : report.status === "Completed"
                          ? styles.statusVerified
                          : styles.statusDraft
                      }
                      style={{
                        padding: "4px 10px",
                        borderRadius: "20px",
                        fontSize: "12px",
                        display: "inline-block",
                        textAlign: "center",
                        minWidth: "100px",
                      }}
                    >
                      {report.status === "Approved L1" ||
                      report.status === "Approved L2" ? (
                        <img src="/aprrovedIcon.svg" />
                      ) : report.status === "Completed" ? (
                        <img src="/successIcon.svg" />
                      ) : report.status === "REJECTED" ? (
                        <img src="/rejectIcon.svg" />
                      ) : (
                        ""
                      )}{" "}
                      {report.status}
                    </span>
                  </div>
                  <div
                    className={styles.cell}
                    style={{ color: "#2348AB" }}
                    onClick={() => {
                      setSelectedRowVal(report);
                      setShowModal(true);
                    }}
                  >
                    {" "}
                    <span>
                      <img className="mx-2" src="./viewIcon.svg" />
                    </span>
                    {"View"}
                  </div>

                  {/*     {(report.created_by === "Maker" &&
                    role.toString() === "Approver L1" &&
                    report.status === "Pending" &&
                    approverLimit > Number(report.amount)) ||
                  (report.created_by === "Maker" &&
                    role.toString() === "Approver L2" &&
                    report.status === "Approved L1" &&
                    approverLimit > Number(report.amount)) ||
                  (report.status === "Pending" &&
                    role.toString() === "Owner") ||
                  (role.toString() === "Super Admin" &&
                    report.status === "Pending" &&
                    approverLimit > Number(report.amount)) ||
                  (role.toString() === "Admin" &&
                    report.status === "Pending" &&
                    approverLimit > Number(report.amount)) ? (
                    <div
                      className={styles.cell}
                      style={{ display: "flex", gap: "8px" }}
                    >
                      <button
                        style={{
                          backgroundColor: "#198754",
                          color: "#FFFFFF",
                          border: "none",
                          borderRadius: "8px",
                          padding: "4px 12px",
                          fontSize: "12px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleAccept(report, "accept", "");
                          console.log("Accepted:", report);
                        }}
                      >
                        Accept
                      </button>
                      <button
                        style={{
                          backgroundColor: "#B20A00",
                          color: "#FFFFFF",
                          border: "1px solid #B20A00",
                          borderRadius: "8px",
                          padding: "4px 12px",
                          fontSize: "12px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setSelectedRowVal(report);
                          setShowRejectModal(true);
                        }}
                      >
                        Reject
                      </button>
                    </div>
                  ) : (report.created_by === "Maker" &&
                      role.toString() === "Approver L1" &&
                      report.status === "Approved L1") ||
                    report.status === "Accepted" ||
                    (report.created_by === "Maker" &&
                      role.toString() === "Approver L2" &&
                      report.status === "Approved L2") ||
                    report.status === "Completed" ? (
                    <div
                      className={styles.cell}
                      style={{ color: "#2348AB" }}
                      onClick={() => {
                        setSelectedRowVal(report);
                        setShowModal(true);
                      }}
                    >
                      <span>
                        <img className="mx-2" src="./viewIcon.svg" />
                      </span>
                      {"View"}
                    </div>
                  ) : (
                    <div
                      className={styles.cell}
                      style={{ color: "#2348AB" }}
                      onClick={() => {
                        setSelectedRowVal(report);
                        setShowModal(true);
                      }}
                    >
                      <span>
                        <img className="mx-2" src="./viewIcon.svg" />
                      </span>
                      {"View"}
                    </div>
                  )} */}
                </div>
              ))
            )}
            {/* <div className="d-flex justify-content-end mt-3"> */}
            <TablePagination
              component="div"
              count={filteredReports?.length || 0}
              page={currentPage}
              onPageChange={(event, newPage) => setCurrentPage(newPage)}
              rowsPerPage={itemsPerPage}
              onRowsPerPageChange={(event) => {
                setItemsPerPage(parseInt(event.target.value, 10));
                setCurrentPage(0); // reset to first page
              }}
              rowsPerPageOptions={[5, 8, 10, 20]}
              sx={{
                "& .MuiTablePagination-selectLabel": {
                  marginTop: "14px",
                },
                "& .MuiTablePagination-displayedRows": {
                  marginTop: "14px",
                },
              }}
            />
            {/* </div> */}
          </div>
        </section>
      </div>
      {showModal && (
        <PayoutViewModal
          page={"view"}
          selectedRowVal={selectedRowVal}
          onClose={() => setShowModal(false)}
          setUserAdded={setUserAdded}
          setRefreshData={setRefreshData}
          setPayoutDetails={setPayoutDetails}
        />
      )}
    </>
  );
};

export default PayoutView;
